import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import RelatoView from '../views/RelatoView.vue'
import CreateUserView from "../views/CreateUserView.vue"; // Importa a nova view

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/relato',
    name: 'relato',
    component: RelatoView,
    meta: { requiresAuth: true } // Marca a rota como protegida
  },
  ,
  {
    path: "/create-user",
    name: "createUser",
    component: CreateUserView,
  },
  {
    // Rota catch-all para redirecionar rotas inexistentes para a página inicial
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Guard global para verificar autenticação
router.beforeEach((to, from, next) => {
  // Verifica se a rota requer autenticação
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Verifica se o token de autenticação está armazenado
    const isAuthenticated = !!localStorage.getItem('token');
    if (!isAuthenticated) {
      // Redireciona para a página de login se não estiver autenticado
      next({ name: 'login' });
    } else {
      next(); // Se autenticado, permite o acesso
    }
  } else {
    next(); // Se a rota não requer autenticação, permite o acesso
  }
});

export default router